import {
    CART_LOADED,
    ADD_TO_CART,
    REDUCE_FROM_CART,
    RESET_CART
} from '../constants/actionTypes';
import _ from 'lodash'
import { BASE_COIN_SYMBOL } from '../constants/config'
import numberHelper from '../util/numberFormatter'
const initialState = {
    cart_items: []
}
export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:
            {
                let cart_items = state.cart_items
                let product = _.find(cart_items, { key: action.payload.key })
                if (!product) {
                    product = action.payload
                    product.qty = 1
                    cart_items = [...state.cart_items, product]
                } else {
                    for (let i in cart_items) {
                        if (cart_items[i].key === product.key) {
                            cart_items[i].qty++
                        }
                    }
                }
                let totalAmount = 0
                cart_items.forEach((item) => {
                    totalAmount += item.qty * item.price
                });
                return {
                    ...state,
                    cart_items: cart_items,
                    cart_amount: numberHelper.Formatter.roundUp(totalAmount, 8)
                }
            }

        case REDUCE_FROM_CART:
            {
                let cart_items = state.cart_items
                let product = _.find(cart_items, { key: action.payload.key })
                if (product.qty === 1) {
                    cart_items = cart_items.filter(item => item.key != action.payload.key)
                } else {
                    for (let i in cart_items) {
                        if (cart_items[i].key === product.key) {
                            cart_items[i].qty--
                        }
                    }
                }
                let totalAmount = 0
                cart_items.forEach((item) => {
                    totalAmount += item.qty * item.price
                });
                return {
                    ...state,
                    cart_items: cart_items,
                    cart_amount: numberHelper.Formatter.roundUp(totalAmount, 8)
                }
            }
        case RESET_CART:
            return {
                ...state,
                cart_items: [],
                cart_amount: 0
            }
        default:
            return state;
    }
};
